"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFetchJson_1 = require("./useFetchJson");
const useQueryData_1 = require("./useQueryData");
const DEFAULT_LANGUAGE = 'en_US';
const useLocalizedJson = (jsonUrl, replacementToken = '%LOCALE%') => {
    const [gameLocale, gameLocaleHasError] = (0, useQueryData_1.default)('game', 'locale');
    const [locale, setLocale] = (0, react_1.useState)('');
    const url = locale ? jsonUrl.replace(replacementToken, locale) : '';
    const [data, loading, error, retry, retryCount] = (0, useFetchJson_1.default)(url);
    (0, react_1.useEffect)(() => {
        if (gameLocale !== null) {
            setLocale(gameLocale);
            return;
        }
        else if ((error && locale !== DEFAULT_LANGUAGE) || !gameLocale) {
            const timer = setTimeout(() => setLocale(DEFAULT_LANGUAGE), 15000);
            return () => clearTimeout(timer);
        }
    }, [error, gameLocale, locale]);
    return [data, loading, error !== null && error !== void 0 ? error : gameLocaleHasError, retry, retryCount];
};
exports.default = useLocalizedJson;
